// extracted by mini-css-extract-plugin
export var actionButton = "_jp-t";
export var buttonContainer = "_jp-0";
export var buttonContainer2 = "_jp-1";
export var buttonSection = "_jp-2";
export var details = "_jp-3";
export var dropdownItem = "_jp-5";
export var dropdownItemsContainer = "_jp-4";
export var fileInput = "_jp-r";
export var headerButton = "_jp-6";
export var icon = "_jp-7";
export var input = "_jp-8";
export var macroListItem = "_jp-9";
export var mainContent = "_jp-a";
export var microText = "_jp-b";
export var modal = "_jp-w";
export var optionsButton = "_jp-c";
export var paperclip = "_jp-s";
export var pillContent = "_jp-d";
export var preview = "_jp-e";
export var preview2 = "_jp-f";
export var quillEditor = "_jp-q";
export var selectedMacro = "_jp-g";
export var sidebar = "_jp-h";
export var sidebarHeader = "_jp-j";
export var sidebarList = "_jp-i";
export var sidebarListItem = "_jp-k";
export var sidebarSearch = "_jp-l";
export var snoozeDurationWrapper = "_jp-v";
export var statusPillContainer = "_jp-m";
export var tagsContainer = "_jp-n";
export var unselectedMacro = "_jp-o";
export var variable = "_jp-u";
export var wrapper = "_jp-p";